import { Document, HeadingLevel, Packer, Paragraph, TextRun } from 'docx';
import { saveAs } from 'file-saver';

export async function exportToDOCX(resumeData, filename = 'resume.docx') {
	const s = resumeData.sections || {};
	const children = [];

	function addHeading(text) {
		children.push(
			new Paragraph({
				text,
				heading: HeadingLevel.HEADING_2
			})
		);
	}
	function addParagraph(text, opts = {}) {
		children.push(
			new Paragraph({
				children: [new TextRun({ text: text || '', ...opts })]
			})
		);
	}
	function addList(items) {
		(items || []).forEach((t) => {
			children.push(new Paragraph({ text: t, bullet: { level: 0 } }));
		});
	}

	// Header
	addParagraph(s.personalInfo?.name || 'Your Name', { bold: true, size: 32 });
	addParagraph(
		[s.personalInfo?.email, s.personalInfo?.phone, s.personalInfo?.location].filter(Boolean).join(' • '),
		{ size: 18 }
	);
	addParagraph('');

	if (s.personalInfo?.summary) {
		addHeading('Professional Summary');
		addParagraph(s.personalInfo.summary);
	}
	if (Array.isArray(s.experience) && s.experience.length) {
		addHeading('Experience');
		s.experience.forEach((e) => {
			addParagraph(`${e.position || ''} • ${e.company || ''}`, { bold: true });
			if (e.description) addParagraph(e.description);
			if (Array.isArray(e.achievements) && e.achievements.length) addList(e.achievements);
		});
	}
	if (Array.isArray(s.education) && s.education.length) {
		addHeading('Education');
		s.education.forEach((ed) => {
			addParagraph(`${ed.degree || ''} • ${ed.institution || ''}`, { bold: true });
			if (ed.field) addParagraph(ed.field);
		});
	}
	if (Array.isArray(s.skills) && s.skills.length) {
		addHeading('Skills');
		s.skills.forEach((cat) => {
			addParagraph(`${cat.category || ''}: ${(cat.items || []).join(', ')}`);
		});
	}

	const doc = new Document({ sections: [{ properties: {}, children }] });
	const blob = await Packer.toBlob(doc);
	saveAs(blob, filename);
}


